import $session from 'servicestack/session'
import $pageConfig from 'webutils/services/page-config';
import $appConfig from 'servicestack/config'

let config = {
    backgroundLayerId: 'EBC-Background',
    hideAddBackground: false,
    allowUploadFromPhone: false,
    autoAddWhiteBackground: false,
    emptyGif:'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    extendedProperties: ['id', 'crossOrigin', 'euid', 'layerId', 'originalLayerId', 'sourcePath', 'groupId', 'fill', 'tint', 'label', 'direction', 'factor', 'originalSrc','isOutOfBounds']
};

export default config